import {IconButton} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import Swal from 'sweetalert2';
import {fetchPatientDetailsUuid} from '../Redux/Thunk/Actions';
import {
  createInpatientHospital,
  createInpatientProcedure,
  createInpatientSchedule,
  deleteInpatientHospital,
  deleteInpatientProcedure,
  getAllInpatientHospital,
  getAllInpatientProcedure,
  getAllInpatientSchedule,
  updateInpatientHospital,
  updateInpatientProcedure,
  updateInpatientSchedule
} from '../Redux/Thunk/inPatientScheduleActions';
import '../styles/Components/AddPatient_form.scss';

import {convertToLocal} from '../utils/dateTime';

function AddPatientScheule({setCloseCreatePopup, loaderchange, editData = null, procedures, hospitals, pagination}) {
  const dispatch = useDispatch();

  const [selectedProcedureDetail, setSelectedProcedureDetail] = useState(null);
  const [selectedHospitalDetail, setSelectedHospitalDetail] = useState(null);
  const [editProcedure, setEditProcedure] = useState(false);
  const [editHospital, setEditHospital] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedType, setSelectedType] = useState('procedure');
  const [openProcedure, setOpenProcedure] = useState(false);
  const [openHospital, setOpenHospital] = useState(false);

  const [formData, setFormData] = useState(() =>
    editData
      ? {...editData}
      : {
          p_uhid: '',
          age: '',
          procedure: '',
          hospital: '',
          transaction_id: null,
          status: 'pending',
          payment_at: null,
          amount: null,
          no_fees: false,
          admission_date: null,
          payment_status: false
        }
  );

  const [validationErrors, setValidationErrors] = useState({});

  const requiredFields = ['p_uhid', 'name', 'procedure', 'hospital', 'admission_date'];

  useEffect(() => {
    if (editData) {
      fetchPatientDetails(editData.p_uhid);
      const matchedProcedure = procedures.find(proc => proc.name === editData.procedure);
      setFormData(prev => ({
        ...prev,
        procedure: matchedProcedure ? matchedProcedure.id : ''
      }));
    }
  }, [editData, procedures]);

  useEffect(() => {
    if (editData) {
      const matchedHospital = hospitals.find(proc => proc.name === editData.hospital);
      setFormData(prev => ({
        ...prev,
        hospital: matchedHospital ? matchedHospital.id : ''
      }));
    }
  }, [editData, hospitals]);

  const validateForm = () => {
    const errors = {};
    requiredFields.forEach(field => {
      if (!formData[field]) {
        errors[field] = 'This field is required';
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = e => {
    const {name, value} = e.target;

    setFormData(prev => ({...prev, [name]: value}));

    if (value.length === 10 && name === 'p_uhid') {
      fetchPatientDetails(value);
    }
  };

  const handleSelectChange = e => {
    const {name, checked} = e.target;

    setFormData(prev => {
      if (name === 'no_fees') {
        return {
          ...prev,
          no_fees: checked,
          payment_status: checked ? false : prev.payment_status,
          payment_at: checked ? '' : prev.payment_at,
          amount: checked ? '' : prev.amount,
          transaction_id: checked ? '' : prev.transaction_id
        };
      } else if (name === 'payment_status') {
        return {
          ...prev,
          payment_status: checked,
          payment_at: checked ? prev.payment_at : ''
        };
      } else {
        return {
          ...prev,
          [name]: checked
        };
      }
    });
  };

  const fetchPatientDetails = async uhid => {
    loaderchange('true'); // if loaderchange accepts boolean

    try {
      const addPatient = fetchPatientDetailsUuid({p_uhid: uhid});
      const response = await dispatch(addPatient).unwrap();
      console.log(`response -->`, response);

      if (response?.status?.code === 200 && response?.data?.data?.length > 0) {
        const patientData = response.data.data[0];
        setFormData(prev => ({
          ...prev,
          name: `${patientData.first_name} ${patientData.last_name}`,
          age: patientData.age,
          patient: patientData.id
        }));
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'No Patient Found.',
          icon: 'warning',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('Error fetching patient details:', error);
      Swal.fire({
        title: 'Error.',
        text: 'Failed to get patient details.',
        icon: 'error',
        showConfirmButton: false,
        timer: 1500
      });
    } finally {
      loaderchange('false');
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;
    loaderchange('true');
    const dataPayload = {
      page: pagination.pageIndex,
      page_size: pagination.pageSize
    };
    try {
      if (editData) {
        try {
          const response = await dispatch(updateInpatientSchedule(formData)).unwrap();
          console.log(`response -->`, response);
          if (response?.status?.code === 200) {
            Swal.fire({
              title: 'Successful.',
              text: 'In patient updated successfully.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            dispatch(getAllInpatientSchedule(dataPayload));
          } else {
            Swal.fire({
              title: 'Error.',
              text: `${response?.status?.message ? response?.status?.message : 'Failed to Update In patient.'}`,
              icon: 'warning',
              showConfirmButton: false,
              timer: 1500
            });
          }
        } catch (error) {
          console.log(`error -->`, error);
          Swal.fire({
            title: 'Error.',
            text: 'Failed to Update In patient.',
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500
          });
        }
      } else {
        try {
          const response = await dispatch(createInpatientSchedule(formData)).unwrap();

          if (response?.status?.code === 201) {
            Swal.fire({
              title: 'Successful.',
              text: 'In patient created successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            dispatch(getAllInpatientSchedule(dataPayload));
          }
        } catch (error) {
          Swal.fire({
            title: 'Error.',
            text: 'Failed to create In patient.',
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
      // setUpdate(prev => !prev);
    } catch (error) {
      console.error('Error saving In patient:', error);
    } finally {
      loaderchange('false');
      setCloseCreatePopup(false);
    }
  };

  const handleAddItem = type => {
    setShowPopUp(true);
    setSelectedType(type);
  };

  const handleDelete = (id, type) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      didOpen: () => {
        document.querySelector('.swal2-container').style.zIndex = '9999';
      }
    }).then(async result => {
      if (result.isConfirmed) {
        if (type === 'procedure') {
          await dispatch(deleteInpatientProcedure(id)).unwrap();
        } else if (type === 'hospital') {
          await dispatch(deleteInpatientHospital(id)).unwrap();
        }
        Swal.fire({
          title: 'Deleted!',
          text: `${type.charAt(0).toUpperCase() + type.slice(1)} has been deleted.`,
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) {
              swalContainer.style.zIndex = '99999';
              swalContainer.style.position = 'fixed';
            }
          }
        });
      }
    });
  };

  const handleEdit = (id, type, flag) => {
    setOpenProcedure(false);
    setOpenHospital(false);
    if (type === 'procedure') {
      const procedure = procedures.find(proc => proc.id === id);
      setSelectedProcedureDetail(procedure);
      setEditProcedure(flag);
    } else if (type === 'hospital') {
      const hospital = hospitals.find(detail => detail.id === id);
      setSelectedHospitalDetail(hospital);
      setEditHospital(flag);
    }
    setShowPopUp(true);
    setSelectedType(type);
  };

  return (
    <>
      <div className='adminform'>
        <div className='modal-dialog1' role='document'>
          <div className='modal-content modelContentChanges'>
            <div className='modal-header'>
              <h5 className='modal-title'>{`${editData ? 'Edit ' : 'Create '}`}InPatient Schedule</h5>
              <button type='button' className='close' onClick={() => setCloseCreatePopup(false)}>
                <i className='bi bi-x-lg'></i>
              </button>
            </div>
            <div className='modal-body modelBodyChanges' style={{padding: '1rem', width: '920px'}}>
              <form onSubmit={handleSubmit}>
                <div className='row my-3'>
                  <div className='col-3'>
                    <label className='form-label'>
                      <span style={{color: 'red'}}>*</span>UHID
                    </label>
                    <input type='text' className='form-control inputStyleChange' name='p_uhid' value={formData.p_uhid} onChange={handleInputChange} placeholder='Search...' />
                    {validationErrors.p_uhid && <small className='text-danger'>{validationErrors.p_uhid}</small>}
                  </div>
                  <div className='col-6'>
                    <label className='form-label'>Name</label>
                    <input type='text' className='form-control inputStyleChange' name='name' value={formData.name} disabled onChange={handleInputChange} placeholder='Name' />
                    {validationErrors.name && <small className='text-danger'>{validationErrors.name}</small>}
                  </div>

                  <div className='col-3'>
                    <label className='form-label'>Age</label>
                    <input type='text' className='form-control inputStyleChange' name='age' value={formData.age} onChange={handleInputChange} placeholder='Age' disabled />
                  </div>
                </div>
                <div className='row my-3'>
                  <div className='col'>
                    <label className='form-label'>
                      <span style={{color: 'red'}}>*</span>Procedure
                    </label>
                    <div className='row'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0px'
                        }}>
                        <Select
                          labelId='procedure-select-label'
                          value={formData.procedure}
                          onChange={handleInputChange}
                          name='procedure'
                          displayEmpty
                          fullWidth
                          open={openProcedure}
                          onOpen={() => setOpenProcedure(true)}
                          onClose={() => setOpenProcedure(false)}
                          sx={{
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            padding: '6px 6px',
                            fontSize: '16px',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#dee2e6'
                            },
                            '& .MuiSelect-select': {
                              padding: '6px'
                            },
                            '&.Mui-focused': {
                              borderColor: '#86b7fe',
                              boxShadow: '0 0 0 0.2rem rgba(13,110,253,.25)'
                            }
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: '230px', // Limit height
                                overflowY: 'auto' // Enable scrolling
                              }
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left'
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            }
                          }}
                          renderValue={selected => (selected ? procedures.find(p => p.id === selected)?.name : 'Select procedure')}>
                          {procedures.map(proc => (
                            <MenuItem
                              key={proc.id}
                              value={proc.id}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '0px 6px',
                                '& span': {
                                  fontSize: '14px'
                                }
                              }}>
                              <span>{proc.name}</span>
                              <div>
                                <IconButton
                                  size='small'
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleEdit(proc.id, 'procedure', true);
                                  }}>
                                  <i style={{marginRight: '0px'}} className='bi bi-pencil'></i>
                                </IconButton>
                                <IconButton
                                  size='small'
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleDelete(proc.id, 'procedure');
                                  }}>
                                  <i style={{marginRight: '0px'}} className='bi bi-trash'>
                                    {' '}
                                  </i>
                                </IconButton>
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                        <button className='Plus mx-2' type='button' onClick={() => handleAddItem('procedure')}>
                          +
                        </button>
                      </div>
                    </div>
                    {validationErrors.procedure && <small className='text-danger'>{validationErrors.procedure}</small>}
                  </div>
                  <div className='col'>
                    <label className='form-label'>
                      <span style={{color: 'red'}}>*</span>Hospital Detail
                    </label>
                    <div className='row'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0px'
                        }}>
                        <Select
                          labelId='hospital-select-label'
                          name='hospital'
                          value={formData.hospital}
                          onChange={handleInputChange}
                          displayEmpty
                          fullWidth
                          open={openHospital}
                          onOpen={() => setOpenHospital(true)}
                          onClose={() => setOpenHospital(false)}
                          sx={{
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            padding: '6px 6px',
                            fontSize: '16px',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#dee2e6'
                            },
                            '& .MuiSelect-select': {
                              padding: '6px'
                            },
                            '&.Mui-focused': {
                              borderColor: '#86b7fe',
                              boxShadow: '0 0 0 0.2rem rgba(13,110,253,.25)'
                            }
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: '230px', // Limit height
                                overflowY: 'auto' // Enable scrolling
                              }
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left'
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            }
                          }}
                          renderValue={selected => (selected ? hospitals.find(h => h.id === selected)?.name : 'Select hospital')}>
                          {hospitals.map(detail => (
                            <MenuItem
                              key={detail.id}
                              value={detail.id}
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '0px 6px',
                                '& span': {
                                  fontSize: '14px'
                                }
                              }}>
                              <span>{detail.name}</span>
                              <div>
                                <IconButton
                                  size='small'
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleEdit(detail.id, 'hospital', true);
                                  }}>
                                  <i style={{marginRight: '0px'}} className='bi bi-pencil'></i>
                                </IconButton>
                                <IconButton
                                  size='small'
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleDelete(detail.id, 'hospital');
                                  }}>
                                  <i style={{marginRight: '0px'}} className='bi bi-trash'></i>
                                </IconButton>
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                        <button className='Plus mx-2' type='button' onClick={() => handleAddItem('hospital')}>
                          +
                        </button>
                      </div>
                    </div>
                    {validationErrors.hospital && <small className='text-danger'>{validationErrors.hospital}</small>}
                  </div>
                </div>

                <div className='row my-4'>
                  <div className='col-md-6'>
                    <div className='border p-4 rounded'>
                      <div className='d-flex align-items-center mb-3'>
                        <label htmlFor='no_fees' className='fw-bold' style={{minWidth: '80px'}}>
                          No Fee:
                        </label>
                        <input type='checkbox' name='no_fees' checked={formData.no_fees} onChange={handleSelectChange} id='no_fees' />
                      </div>

                      {/* Amount Input */}
                      <div className='row'>
                        <div className='col-md-6 d-flex align-items-center mb-3'>
                          <label htmlFor='amount' className='fw-bold me-2' style={{minWidth: '70px'}}>
                            Amount:
                          </label>
                          <input
                            type='number'
                            className='form-control flex-grow-1'
                            value={formData.amount}
                            name='amount'
                            onInput={handleInputChange}
                            placeholder='Amount'
                            disabled={formData.no_fees}
                            style={{
                              border: '1px solid rgba(65, 63, 63, .5)',
                              borderRadius: '4px',
                              padding: '5px'
                            }}
                          />
                        </div>
                        <div className='col-md-6 d-flex align-items-center mb-3'>
                          {/* <label htmlFor='txnNo' className='fw-bold me-2' style={{minWidth: '80px'}}>
                            Txn No.:
                          </label> */}
                          <input
                            type='text'
                            className='form-control flex-grow-1'
                            value={formData.transaction_id}
                            name='transaction_id'
                            onInput={handleInputChange}
                            placeholder='Txn No.'
                            disabled={formData.no_fees}
                            style={{
                              border: '1px solid rgba(65, 63, 63, .5)',
                              borderRadius: '4px',
                              padding: '5px'
                            }}
                          />
                        </div>
                      </div>

                      {/* Paid Status Checkbox */}
                      <div className='d-flex align-items-center mb-3'>
                        <label htmlFor='payment_status' className='fw-bold' style={{minWidth: '80px'}}>
                          Paid:
                        </label>
                        <input type='checkbox' name='payment_status' checked={formData.payment_status} disabled={formData.no_fees} onChange={handleSelectChange} id='payment_status' />
                      </div>

                      {/* Paid In Radio Buttons */}
                      <div className='d-flex align-items-center'>
                        <label className='fw-bold' style={{minWidth: '80px'}}>
                          Paid In:
                        </label>
                        <div className='d-flex gap-3'>
                          <div className='d-flex align-items-center'>
                            <input
                              type='radio'
                              name='payment_at'
                              value='clinic'
                              checked={formData.payment_at === 'clinic'}
                              onChange={handleInputChange}
                              id='clinic'
                              disabled={!formData.payment_status}
                            />
                            <label htmlFor='clinic' className='ms-2'>
                              Clinic
                            </label>
                          </div>

                          <div className='d-flex align-items-center'>
                            <input
                              type='radio'
                              name='payment_at'
                              value='hospital'
                              checked={formData.payment_at === 'hospital'}
                              onChange={handleInputChange}
                              id='hospital'
                              disabled={!formData.payment_status}
                            />
                            <label htmlFor='hospital' className='ms-2'>
                              Hospital
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='col'>
                    <div className='col'>
                      <label>
                        <span style={{color: 'red'}}>*</span>Date :
                      </label>
                      <br />
                      <input
                        onChange={handleInputChange}
                        name='admission_date'
                        type='datetime-local'
                        autoComplete='off'
                        className='form-control inputStyleChange'
                        value={formData.admission_date ? convertToLocal(formData.admission_date) : ''}
                      />
                      {validationErrors.admission_date && <small className='text-danger'>{validationErrors.admission_date}</small>}
                    </div>
                    <div className='col my-3'>
                      <label className='form-label'>Status</label>
                      <select className='form-select ' name='status' value={formData.status} onChange={handleInputChange}>
                        <option value='pending'>Pending</option>
                        <option value='complete'>Complete</option>
                        <option value='cancel'>Cancel</option>
                      </select>
                      {validationErrors.status && <small className='text-danger'>{validationErrors.status}</small>}
                    </div>
                  </div>
                </div>

                <div className='modal-footer'>
                  <button type='submit' className='btn btn-primary'>
                    {`${editData ? 'Update ' : 'Create '}`}InPatient Schedule
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showPopUp && (
        <AddDetails
          setShowPopUp={setShowPopUp}
          selectedType={selectedType}
          editProcedure={editProcedure}
          setEditProcedure={setEditProcedure}
          selectedProcedureDetail={selectedProcedureDetail}
          setSelectedProcedureDetail={setSelectedProcedureDetail}
          editHospital={editHospital}
          setEditHospital={setEditHospital}
          selectedHospitalDetail={selectedHospitalDetail}
          setSelectedHospitalDetail={setSelectedHospitalDetail}
        />
      )}
    </>
  );
}

const AddDetails = ({
  setShowPopUp,
  selectedType,
  editProcedure,
  setEditProcedure,
  selectedProcedureDetail,
  setSelectedProcedureDetail,
  editHospital,
  selectedHospitalDetail,
  setEditHospital,
  setSelectedHospitalDetail
}) => {
  const [procedureDetail, setProcedureDetail] = useState(selectedProcedureDetail || {id: null, name: ''});

  const [hospitalDetail, setHospitalDetail] = useState(
    selectedHospitalDetail || {
      id: null,
      name: '',
      phone_number: '',
      email: '',
      address: ''
    }
  );

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (editHospital && selectedHospitalDetail) {
  //     setSelectedHospitalDetail(selectedHospitalDetail);
  //   }
  // }, [editHospital, selectedHospitalDetail]);

  // useEffect(() => {
  //   if (editProcedure && selectedProcedureDetail) {
  //     setProcedureDetail(selectedProcedureDetail);
  //   }
  // }, [editProcedure, selectedProcedureDetail]);

  const handleInputChange = e => {
    const {name, value} = e.target;
    if (selectedType === 'procedure') {
      setProcedureDetail(prev => ({...prev, [name]: value}));
    } else if (selectedType === 'hospital') {
      setHospitalDetail(prev => ({...prev, [name]: value}));
    }
  };

  const addOrUpdate = async e => {
    e.preventDefault();
    setShowPopUp(false);
    try {
      if (selectedType === 'procedure') {
        if (!editProcedure) {
          const response = await dispatch(createInpatientProcedure({name: procedureDetail.name})).unwrap();
          Swal.fire({
            title: 'Success.',
            text: 'Procedure saved.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getAllInpatientProcedure());
        } else {
          dispatch(
            updateInpatientProcedure({
              id: procedureDetail.id,
              name: procedureDetail.name
            })
          );
          Swal.fire({
            title: 'Success.',
            text: 'Procedure updated.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getAllInpatientProcedure());
        }
      } else if (selectedType === 'hospital') {
        if (!editHospital) {
          dispatch(createInpatientHospital(hospitalDetail));
          Swal.fire({
            title: 'Success.',
            text: 'Hospital saved.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getAllInpatientHospital());
        } else {
          const {id, name, phone_number, email, address} = hospitalDetail;
          dispatch(
            updateInpatientHospital({
              id,
              data: {name, phone_number, email, address}
            })
          );
          Swal.fire({
            title: 'Success.',
            text: 'Hospital updated.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          dispatch(getAllInpatientHospital());
        }
      }
    } catch (error) {
      Swal.fire({
        title: 'Error.',
        text: 'Failed to save.',
        icon: 'warning',
        showConfirmButton: false,
        timer: 1500
      });
    }
  };
  const resetForm = () => {
    setShowPopUp(false);
    setEditProcedure(false);
    setSelectedProcedureDetail(null);
    setEditHospital(false);
    setSelectedHospitalDetail(null);
    setHospitalDetail({id: null, name: '', phone_number: '', email: '', address: ''});
  };

  return (
    <div className='adminform'>
      <div className={selectedType === 'procedure' ? 'modal-sm' : 'modal-md'} role='document'>
        <div className='modal-content modelContentChanges'>
          <div className='modal-header'>
            <h5 className='modal-title'>{selectedType === 'procedure' ? 'Procedure' : 'Hospital Details'}</h5>
            <button type='button' className='close' data-dismiss='modal' aria-label='Close' onClick={() => resetForm()}>
              <i className='bi bi-x-lg'></i>
            </button>
          </div>
          <div
            className='modal-body modelBodyChanges'
            style={{
              padding: '1rem',
              width: selectedType === 'procedure' ? '400px' : '720px'
            }}>
            <form onSubmit={addOrUpdate}>
              <div className='row my-2'>
                {selectedType === 'procedure' ? (
                  <div className='col my-0'>
                    <label htmlFor='name' className='form-label'>
                      <span style={{color: 'red'}}>*</span>Procedure Name
                    </label>
                    <input
                      type='text'
                      className='form-control inputStyleChange'
                      id='name'
                      name='name'
                      autoComplete='off'
                      placeholder='Enter Procedure'
                      onChange={handleInputChange}
                      value={procedureDetail?.name || ''}
                    />
                  </div>
                ) : (
                  <>
                    <div className='row mt-3'>
                      <div className='col col-md-6'>
                        <label htmlFor='name' className='form-label'>
                          <span style={{color: 'red'}}>*</span>Hospital Name
                        </label>
                        <input
                          type='text'
                          className='form-control inputStyleChange'
                          id='name'
                          name='name'
                          autoComplete='off'
                          placeholder='Enter Hospital Name'
                          onChange={handleInputChange}
                          value={hospitalDetail?.name || ''}
                        />
                      </div>
                      <div className='col'>
                        <label htmlFor='phone_number' className='form-label'>
                          Phone No
                        </label>
                        <input
                          type='number'
                          className='form-control inputStyleChange'
                          id='phone_number'
                          name='phone_number'
                          autoComplete='off'
                          placeholder='Phone No'
                          onChange={handleInputChange}
                          value={hospitalDetail?.phone_number || ''}
                        />
                      </div>
                    </div>

                    <div className='row mt-3 mr-3'>
                      <label htmlFor='address' className='form-label'>
                        Hospital Address
                      </label>
                      <textarea
                        className='form-control inputStyleChange'
                        id='address'
                        name='address'
                        autoComplete='off'
                        placeholder='Enter Hospital Address'
                        onChange={handleInputChange}
                        value={hospitalDetail?.address || ''}
                        rows={5}
                        style={{
                          height: 'auto',
                          minHeight: '100px',
                          marginLeft: '10px'
                        }}></textarea>
                    </div>
                  </>
                )}
              </div>
              <div className='modal-footer'>
                <button type='submit' className='save-button'>
                  {selectedType === 'procedure' ? (editProcedure ? 'Update' : 'Save') : editHospital ? 'Update' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPatientScheule;
